import {
  LOAD_FIRESTORE_DATA,
  FIRESTORE_ERROR,
  LOAD_FIRESTORE_DOC,
  LOADING_DOC,
  DOC_LOADED,
  LOADING_COLLECTION,
  COLLECTION_LOADED,
  UNLOAD_DOCS,
  LOAD_BRANCHES,
  LOAD_MANAGED_BRANCHES,
} from "../actions/firestore";

const initialState = {
  data: {
    loading: false,
  },
  ordered: {
    loading: false,
  },
  docs: {
    loading: false,
  },
  error: null,
};

const firestore = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAD_FIRESTORE_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload.data,
        },
        ordered: {
          ...state.ordered,
          ...payload.ordered,
        },
      };
    case LOADING_COLLECTION:
      return {
        ...state,
        data: {
          ...state.data,
          loading: true,
        },
        ordered: {
          ...state.ordered,
          loading: true,
        },
      };
    case COLLECTION_LOADED:
      return {
        ...state,
        data: {
          ...state.data,
          loading: false,
        },
        ordered: {
          ...state.ordered,
          loading: false,
        },
      };
    case LOADING_DOC:
      return {
        ...state,
        docs: {
          ...state.docs,
          loading: true,
        },
      };
    case DOC_LOADED:
      return {
        ...state,
        docs: {
          ...state.docs,
          loading: false,
        },
      };
    case LOAD_FIRESTORE_DOC:
      return {
        ...state,
        docs: {
          ...state.docs,
          ...payload,
        },
      };

    case LOAD_BRANCHES:
      return {
        ...state,
        docs: {
          ...state.docs,
          branches: {
            delivery: payload.data,
          },
        },
      };

    case LOAD_MANAGED_BRANCHES:
      return {
        ...state,
        docs: {
          ...state.docs,
          managedBranches: {
            delivery: payload.data,
          },
        },
      };

    case UNLOAD_DOCS:
      return {
        ...state,
        data: {
          loading: false,
        },
        ordered: {
          loading: false,
        },
        docs: {
          loading: false,
        },
      };

    case FIRESTORE_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default firestore;
